var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "add-examine",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("类型"),
      visible: _vm.visible,
      width: 840
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("类型名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核进度")
    }
  }, [_c("plan", {
    attrs: {
      planList: _vm.planList
    },
    on: {
      save: _vm.updateList,
      update: _vm.getDetail
    }
  }), _c("span", {
    staticStyle: {
      color: "#0b91cc"
    }
  }, [_vm._v("* " + _vm._s(_vm.$t("请按照正序添加进度")))])], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };